module.exports = __webpack_public_path__ + "795253339e4d73518c2137ce96db8b80.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/snd/end.mp3
// module id = 514
// module chunks = 0